import type { WatchdogCountData } from 'service/watchdog/model.ts';
import { CATEGORY_ALL_CATEGORIES_SEO_NAME, LOCALITY_CELA_CR, PRICE, type TLocality } from 'utils/constants.ts';
import { type FilerPrice, getCategory, getSort, type URLFilterParams } from './url';
import type { LocalityData } from 'service/locality/model';
import { dateToRemoteTimestamp } from 'utils/date.ts';
import { getLocalityName, getLocalitySeoName } from 'utils/getLocalityName.ts';
import { getKdeParameter } from 'utils/locality';
import { CATEGORY_ALL_CATEGORIES } from 'service/category/model.ts';

export function filterPriceToUrlPrice(price: {
	priceForFree?: boolean;
	priceTo?: number;
	priceFrom?: number;
}): FilerPrice {
	if (price.priceForFree) {
		return {
			type: PRICE.FREE,
			seoName: PRICE.FREE,
		};
	}

	if (price.priceFrom !== undefined && price.priceTo !== undefined) {
		return {
			from: price.priceFrom,
			to: price.priceTo,
			type: PRICE.BETWEEN,
			seoName: `od-${price.priceFrom}-do-${price.priceTo}-kc`,
		};
	}

	if (price.priceFrom !== undefined) {
		return {
			from: price.priceFrom,
			type: PRICE.FROM,
			seoName: `od-${price.priceFrom}-kc`,
		};
	}

	if (price.priceTo !== undefined) {
		return {
			to: price.priceTo,
			type: PRICE.TO,
			seoName: `do-${price.priceTo}-kc`,
		};
	}

	return {
		type: PRICE.NO_LIMIT,
		seoName: PRICE.NO_LIMIT,
	};
}

export function filterLocalityToFilterLocality(locality?: LocalityData): TLocality {
	return locality
		? {
				seoName: getLocalitySeoName(locality),
				name: getLocalityName(locality),
				id: locality.entityId,
				type: locality.entityType,
			}
		: LOCALITY_CELA_CR;
}

export function watchdogFilterToUrlFilterParams(watchdog: WatchdogCountData): URLFilterParams {
	try {
		const hledej = { seoName: watchdog.filter?.phrase };
		const category = getCategory(
			watchdog.filter.categoryId?.toString() ?? CATEGORY_ALL_CATEGORIES_SEO_NAME,
			CATEGORY_ALL_CATEGORIES,
		);
		const locality = filterLocalityToFilterLocality(watchdog.filter.locality);
		const price = filterPriceToUrlPrice(watchdog.filter);
		const sort = getSort();
		const pageNumber = Number(1);
		const page = {
			seoName: pageNumber.toString(),
			value: pageNumber,
		};
		const watchdog_hash = { seoName: watchdog.newCount ? watchdog.watchdogHash : undefined };
		const watchdog_id = { seoName: watchdog.newCount ? String(watchdog.id) : undefined };
		const watchdog_timestamp = {
			seoName: watchdog.newCount ? dateToRemoteTimestamp(watchdog.timestamp) : undefined,
		};
		const kde = { seoName: watchdog.filter.locality && getKdeParameter(watchdog.filter.locality) };
		const radius = {
			seoName: watchdog.filter.radiusPrecision !== undefined ? String(watchdog.filter.radiusPrecision) : '0', // backend has default as 0, but we have default as 5
		};
		const dohodou = { seoName: watchdog.filter.hidePriceByAgreement ? 'bez' : undefined };

		return {
			hledej,
			category,
			expiring: { value: undefined },
			locality,
			price,
			sort,
			page,
			watchdog_hash,
			watchdog_id,
			watchdog_timestamp,
			kde,
			radius,
			dohodou,
			rozbalene: undefined, // not supported
		};
	} catch (error: any) {
		throw new Error('Invalid URL: ' + error.message);
	}
}
